import { useEffect, useRef, useState } from 'react';
import styles from './index.module.less';
import { useGetConfig } from '../../useGetConfig';
import { PointType } from '../../typings';
import { ProductTracker } from '@/utils/Tracker';
import ossImgCompress from '@/utils/ossImgCompress';

const SceneViewDisplay = ({ changeModule }: { changeModule: (point: PointType) => void }) => {
  const {
    sceneviewConfig,
    mobxStore: {
      product: { productDetail, curSelectCommodity },
      app: { webp },
    },
  } = useGetConfig();
  const videoWrapRef = useRef<HTMLDivElement & { videoRef: HTMLVideoElement }>(null);
  const pointWrapRef = useRef<HTMLDivElement>(null);
  const [showSceneImg, setShowSceneImg] = useState(false);

  useEffect(() => {
    pointWrapRef.current?.classList.remove(styles.active);
  }, [sceneviewConfig?.startVideo]);

  useEffect(() => {
    if (!videoWrapRef.current) return;
    // 先去除点
    if (pointWrapRef.current) {
      pointWrapRef.current.style.transition = 'none';
      pointWrapRef.current?.classList.remove(styles.active);
    }

    videoWrapRef.current.videoRef = videoWrapRef.current.childNodes[0] as HTMLVideoElement;
    videoWrapRef.current.videoRef.addEventListener('ended', () => {
      if (pointWrapRef.current) {
        pointWrapRef.current.style.transition = '0.3s ease opacity';
        pointWrapRef.current?.classList.add(styles.active);
      }
    });

    // 第一次进入页面播放开场动画
    videoWrapRef?.current?.videoRef
      ?.play()
      .then(() => {
        setShowSceneImg(false);
        pointWrapRef.current?.classList.remove(styles.active);
      })
      .catch(() => {
        // 如果开场动画不能自动播放，则显示兜底场景图
        setShowSceneImg(true);
        pointWrapRef.current?.classList.add(styles.active);
      });
  }, [sceneviewConfig?.startVideo]);

  const replayAni = () => {
    if (!videoWrapRef.current) return;
    pointWrapRef.current?.classList.remove(styles.active);
    setShowSceneImg(false);

    if (!videoWrapRef.current.videoRef) return;
    videoWrapRef.current.videoRef.currentTime = 0;
    videoWrapRef.current.videoRef?.play();
  };

  return (
    <section className={styles.sceneViewDisplayWrap}>
      <div ref={videoWrapRef} className={styles.playAniVideo}>
        <video
          muted
          disablePictureInPicture
          playsInline
          controls={false}
          poster={ossImgCompress(sceneviewConfig?.startPoster ?? '', { webp })}
          src={sceneviewConfig?.startVideo}
        />
      </div>
      {showSceneImg && (
        <div className={styles.sceneImgWrap}>
          <img src={ossImgCompress(sceneviewConfig?.sceneImg || '', { webp })} alt='' />
        </div>
      )}
      <div ref={pointWrapRef} className={styles.sceneViewDisplay}>
        {sceneviewConfig?.pointList?.map((point, index) => {
          return (
            <span
              key={`${point.y}-${point.x}-${index}`}
              style={{
                marginTop: `${point.y}%`,
                marginLeft: `${point.x}%`,
              }}
              className={styles.point}
              onClick={() => {
                changeModule(point);
                ProductTracker.productPageImages({
                  action: 'click_scene_point',
                  data: {
                    url_key: productDetail?.url_key,
                    name: curSelectCommodity?.name,
                    id: curSelectCommodity?.id,
                  },
                  category: 'product_image',
                });
              }}
            />
          );
        })}
        <div
          className={styles.rePlayBtn}
          onClick={() => {
            replayAni();
            ProductTracker.productPageImages({
              action: 'scenario_replay_btn_click',
              data: {
                url_key: productDetail?.url_key,
                name: curSelectCommodity?.name,
                id: curSelectCommodity?.id,
              },
              category: 'product_image',
            });
          }}
        >
          <img src='https://res.insta360.com/static/8213ffcc2099a78b8bca4a9ebd19740c/%E9%87%8D%E7%BD%AE.png' alt='' />
        </div>
      </div>
    </section>
  );
};

export default SceneViewDisplay;
